export class AbonementModel {
	constructor() {
		/**
		 * Текущий шаг или сотояние
		 * @example window.ABONEMENT_STATE = prices | split
		 * prices - Расположение и цены
		 * split - Выбор места
		 */
		this.state = window.ABONEMENT_STATE || null;
	}
}
